(function() {
  function initFlexibleColumnsSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.bsgFlexibleColumnsInitialized === 'true') return;
    if (sectionRoot.querySelector('[data-bsg-flexible-tabs], [data-bsg-flexible-dropdown]')) return;
    sectionRoot.dataset.bsgFlexibleColumnsInitialized = 'true';

  const slider = sectionRoot.querySelector('.flexible-columns-slider');
  const mobileSliderWrapper = sectionRoot.querySelector('.mobile-slider-wrapper');
  const scrollHint = sectionRoot.querySelector('.gf-scroll-hint');
  const prevButton = sectionRoot.querySelector('button[name="previous"]');
  const nextButton = sectionRoot.querySelector('button[name="next"]');
  const sectionId = sectionRoot.id ? sectionRoot.id.replace(/^shopify-section-/, '') : '';
  const popupOverlay = sectionId ? document.getElementById('GFPopupOverlay-' + sectionId) : null;
  const popupModal = popupOverlay ? popupOverlay.querySelector('.gf-popup-modal') : null;
  const popupContent = sectionId ? document.getElementById('GFPopupContent-' + sectionId) : null;
  const popupCloseButton = popupOverlay ? popupOverlay.querySelector('[data-popup-close]') : null;
  const popupTriggers = sectionRoot.querySelectorAll('.gf-popup-trigger');
  const alignedFieldKeys = [
    'above-eyebrow',
    'eyebrow',
    'heading',
    'text',
    'subtext',
    'price',
    'html',
    'liquid',
    'cta',
    'below-cta'
  ];
  let normalizeTimer = null;
  let scrollHintAnimationFrame = null;
  let hasHorizontalScrollStarted = false;
  let scrollHintTargetOffset = 0;
  let scrollHintCurrentOffset = 0;
  let scrollHintMotionFrame = null;
  let scrollHintHasPosition = false;

  function getPopupPayload(payloadId) {
    if (!payloadId) return null;

    const payloadScript = document.getElementById(payloadId);
    if (!payloadScript) return null;

    try {
      return JSON.parse(payloadScript.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function setPopupArticleStyleState(enabled) {
    if (!popupOverlay || !popupModal || !popupContent) return;

    const isArticleStyle = enabled === true;
    popupOverlay.classList.toggle('is-article-style', isArticleStyle);
    popupModal.classList.toggle('is-article-style', isArticleStyle);
    popupContent.classList.toggle('is-article-style', isArticleStyle);
  }

  function closePopupModal() {
    if (!popupOverlay || !popupContent) return;

    setPopupArticleStyleState(false);
    popupOverlay.style.display = 'none';
    popupContent.innerHTML = '';
    popupOverlay.setAttribute('aria-hidden', 'true');
  }

  function openPopupModal(payload) {
    if (!popupOverlay || !popupContent || !payload) return;

    const hasLinks = Array.isArray(payload.links) && payload.links.length;
    const hasImages = Array.isArray(payload.images) && payload.images.length;
    const hasContent = payload.html || payload.header || payload.body || hasLinks || hasImages;
    const isArticleStyle = payload.articleStyle === true;

    if (!hasContent) return;
    setPopupArticleStyleState(isArticleStyle);

    if (payload.html) {
      popupContent.innerHTML = isArticleStyle
        ? '<article class="gf-popup-article">' + payload.html + '</article>'
        : payload.html;
      popupOverlay.style.display = 'block';
      popupOverlay.setAttribute('aria-hidden', 'false');
      return;
    }

    let imagesHtml = '';
    if (hasImages) {
      const imageCount = payload.images.length;
      const imageRowClass = 'gf-popup-image-row' + (payload.imagesRounded ? ' is-rounded' : '');
      imagesHtml = '<div class="' + imageRowClass + '" data-count="' + imageCount + '">' +
        payload.images.map(function(image) {
          return '<img src="' + image.src + '" alt="' + (image.alt || '') + '">';
        }).join('') +
      '</div>';
    }

    let linksHtml = '';
    if (hasLinks) {
      const inlineLinks = payload.linksInline !== false;
      const builtLinks = payload.links.map(function(link) {
        return '<a href="' + link.href + '" class="alerting-link">' +
          '<span class="alerting-link-text">' + link.label + '</span>' +
          '<span class="arrow">❯</span>' +
        '</a>';
      });

      linksHtml = inlineLinks
        ? '<p>' + builtLinks.join(' | ') + '</p>'
        : builtLinks.map(function(linkHtml) { return '<p>' + linkHtml + '</p>'; }).join('');
    }

    const bodyHtml = payload.body
      ? (payload.body.indexOf('<') === -1 ? '<p>' + payload.body + '</p>' : payload.body)
      : '';

    let popupMarkup =
      (payload.header ? '<p><strong>' + payload.header + '</strong></p>' : '') +
      imagesHtml +
      bodyHtml +
      linksHtml;

    if (isArticleStyle) {
      popupMarkup = '<article class="gf-popup-article">' + popupMarkup + '</article>';
    }

    popupContent.innerHTML = popupMarkup;

    popupOverlay.style.display = 'block';
    popupOverlay.setAttribute('aria-hidden', 'false');
  }

  function clampProgress(value) {
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
  }

  if (popupOverlay && popupCloseButton) {
    setPopupArticleStyleState(false);
    popupOverlay.setAttribute('aria-hidden', 'true');

    popupTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        const payloadId = trigger.getAttribute('data-popup-payload-id');
        const payload = getPopupPayload(payloadId);
        openPopupModal(payload);
      });
    });

    popupOverlay.addEventListener('click', function() {
      closePopupModal();
    });

    popupCloseButton.addEventListener('click', function(event) {
      event.preventDefault();
      closePopupModal();
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && popupOverlay.style.display === 'block') {
        closePopupModal();
      }
    });
  }

  function updateMobileScrollHint() {
    if (!slider || !scrollHint || !mobileSliderWrapper) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const canScrollHorizontally = slider.scrollWidth - slider.clientWidth > 4;
    if (slider.scrollLeft > 4) {
      hasHorizontalScrollStarted = true;
    }

    const shouldHideHint = !isMobile || !canScrollHorizontally || hasHorizontalScrollStarted;
    sectionRoot.classList.toggle('gf-scroll-hint-hidden', shouldHideHint);
    if (shouldHideHint) {
      scrollHint.setAttribute('aria-hidden', 'true');
      scrollHint.setAttribute('tabindex', '-1');
      scrollHint.disabled = true;
    } else {
      scrollHint.setAttribute('aria-hidden', 'false');
      scrollHint.removeAttribute('tabindex');
      scrollHint.disabled = false;
    }

    const rect = mobileSliderWrapper.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const progress = clampProgress((viewportHeight - rect.top) / (viewportHeight + rect.height));
    const startOffset = 12;
    const hintHeight = scrollHint.offsetHeight || 42;
    const endOffset = Math.max(startOffset, mobileSliderWrapper.clientHeight - hintHeight - 12);
    const topOffset = startOffset + (endOffset - startOffset) * progress;
    scrollHintTargetOffset = topOffset;

    if (!scrollHintHasPosition) {
      scrollHintCurrentOffset = topOffset;
      scrollHint.style.setProperty('--gf-scroll-hint-offset', scrollHintCurrentOffset.toFixed(2) + 'px');
      scrollHintHasPosition = true;
      return;
    }

    if (scrollHintMotionFrame) return;
    scrollHintMotionFrame = window.requestAnimationFrame(function animateScrollHintOffset() {
      scrollHintMotionFrame = null;
      const delta = scrollHintTargetOffset - scrollHintCurrentOffset;
      if (Math.abs(delta) < 0.2) {
        scrollHintCurrentOffset = scrollHintTargetOffset;
      } else {
        scrollHintCurrentOffset = scrollHintCurrentOffset + delta * 0.25;
      }
      scrollHint.style.setProperty('--gf-scroll-hint-offset', scrollHintCurrentOffset.toFixed(2) + 'px');
      if (Math.abs(scrollHintTargetOffset - scrollHintCurrentOffset) >= 0.2) {
        scrollHintMotionFrame = window.requestAnimationFrame(animateScrollHintOffset);
      }
    });
  }

  function queueMobileScrollHintUpdate() {
    if (scrollHintAnimationFrame) return;
    scrollHintAnimationFrame = window.requestAnimationFrame(function() {
      scrollHintAnimationFrame = null;
      updateMobileScrollHint();
    });
  }

  function getHintSlideDistance() {
    if (!slider) return 0;

    const slideItems = slider.querySelectorAll('.slider-item');
    if (!slideItems.length) return slider.clientWidth;

    const firstSlide = slideItems[0];
    if (slideItems.length > 1) {
      const stepDistance = slideItems[1].offsetLeft - firstSlide.offsetLeft;
      if (stepDistance > 0) return stepDistance;
    }

    return firstSlide.offsetWidth || slider.clientWidth;
  }

  function getVisibleCards(container) {
    return Array.from(container.querySelectorAll('.gf-align-card')).filter(function(card) {
      return card.getClientRects().length > 0;
    });
  }

  function groupCardsByTop(cards) {
    const rows = [];
    const tolerance = 4;

    cards.forEach(function(card) {
      const top = Math.round(card.getBoundingClientRect().top);
      let row = null;

      for (let i = 0; i < rows.length; i += 1) {
        if (Math.abs(rows[i].top - top) <= tolerance) {
          row = rows[i];
          break;
        }
      }

      if (!row) {
        row = { top: top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows;
  }

  function normalizeFieldHeightsInCards(cards) {
    alignedFieldKeys.forEach(function(fieldKey) {
      const selector = '.gf-field--' + fieldKey;
      const fields = cards.map(function(card) {
        return card.querySelector(selector);
      }).filter(Boolean);

      if (!fields.length) return;

      fields.forEach(function(field) {
        field.style.minHeight = '';
      });

      let maxHeight = 0;
      fields.forEach(function(field) {
        if (field.offsetHeight > maxHeight) {
          maxHeight = field.offsetHeight;
        }
      });

      if (maxHeight > 0) {
        fields.forEach(function(field) {
          field.style.minHeight = maxHeight + 'px';
        });
      }
    });
  }

  function normalizeFlexibleColumnRows() {
    const containers = sectionRoot.querySelectorAll('.flexible-columns-grid, .flexible-columns-slider');

    containers.forEach(function(container) {
      container.querySelectorAll('.gf-field').forEach(function(field) {
        field.style.minHeight = '';
      });

      const cards = getVisibleCards(container);
      if (!cards.length) return;

      const rows = groupCardsByTop(cards);
      rows.forEach(function(row) {
        normalizeFieldHeightsInCards(row.cards);
      });
    });
  }

  function queueNormalizeFlexibleColumnRows() {
    window.clearTimeout(normalizeTimer);
    normalizeTimer = window.setTimeout(normalizeFlexibleColumnRows, 90);
  }

  if (slider && prevButton && nextButton) {
    const slideItems = slider.querySelectorAll('.slider-item');
    if (slideItems.length) {
      let currentPage = 1;
      let slideDistance = 0;
      let totalPages = 1;

      function initPages() {
        const firstSlide = slideItems[0];
        if (!firstSlide) return false;

        if (slideItems.length > 1) {
          slideDistance = slideItems[1].offsetLeft - firstSlide.offsetLeft;
        } else {
          slideDistance = firstSlide.offsetWidth;
        }

        if (!slideDistance) return false;

        const slidesPerPage = Math.max(1, Math.floor((slider.clientWidth - firstSlide.offsetLeft) / slideDistance));
        totalPages = Math.max(1, slideItems.length - slidesPerPage + 1);
        return true;
      }

      function clampPage(page) {
        if (page < 1) return 1;
        if (page > totalPages) return totalPages;
        return page;
      }

      function updateButtons() {
        currentPage = clampPage(currentPage);
        prevButton.toggleAttribute('disabled', currentPage <= 1);
        nextButton.toggleAttribute('disabled', currentPage >= totalPages);
      }

      function updateIndexFromScroll() {
        if (!initPages()) return;
        currentPage = clampPage(Math.round(slider.scrollLeft / slideDistance) + 1);
        updateButtons();
      }

      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (!initPages()) return;
        currentPage = clampPage(currentPage - 1);
        slider.scrollTo({ left: (currentPage - 1) * slideDistance, behavior: 'smooth' });
        updateButtons();
      });

      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (!initPages()) return;
        currentPage = clampPage(currentPage + 1);
        slider.scrollTo({ left: (currentPage - 1) * slideDistance, behavior: 'smooth' });
        updateButtons();
      });

      let scrollTimer = null;
      slider.addEventListener('scroll', function() {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateIndexFromScroll, 70);
        queueMobileScrollHintUpdate();
      }, { passive: true });

      window.addEventListener('resize', function() {
        updateIndexFromScroll();
        queueNormalizeFlexibleColumnRows();
        queueMobileScrollHintUpdate();
      });
      initPages();
      updateButtons();
      queueNormalizeFlexibleColumnRows();
      queueMobileScrollHintUpdate();
    }
  }

  // Lazy autoplay videos when visible
  const lazyVideos = sectionRoot.querySelectorAll('video.lazy-autoplay-video');
  if (lazyVideos.length && 'IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        const video = entry.target;
        if (!video) return;

        if (entry.isIntersecting) {
          try {
            video.play();
          } catch (e) {}
        } else {
          try {
            video.pause();
          } catch (e) {}
        }
      });
    }, {
      root: null,
      rootMargin: '200px 0px',
      threshold: 0.25
    });

    lazyVideos.forEach(function(video) {
      videoObserver.observe(video);
    });
  }

  sectionRoot.querySelectorAll('img').forEach(function(image) {
    image.addEventListener('load', queueNormalizeFlexibleColumnRows, { passive: true });
  });

  sectionRoot.querySelectorAll('video').forEach(function(video) {
    video.addEventListener('loadedmetadata', queueNormalizeFlexibleColumnRows, { passive: true });
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(queueNormalizeFlexibleColumnRows).catch(function() {});
  }

  if (scrollHint && slider) {
    scrollHint.addEventListener('click', function(e) {
      e.preventDefault();
      if (scrollHint.disabled) return;
      const stepDistance = getHintSlideDistance();
      if (stepDistance > 0) {
        const maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
        const targetLeft = Math.min(maxLeft, slider.scrollLeft + stepDistance);
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        slider.scrollTo({ left: targetLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      }
      hasHorizontalScrollStarted = true;
      sectionRoot.classList.add('gf-scroll-hint-hidden');
      queueMobileScrollHintUpdate();
    });
  }

  window.addEventListener('scroll', queueMobileScrollHintUpdate, { passive: true });
  window.addEventListener('load', queueNormalizeFlexibleColumnRows);
  window.addEventListener('load', queueMobileScrollHintUpdate);
  window.addEventListener('resize', queueNormalizeFlexibleColumnRows);
  window.addEventListener('resize', queueMobileScrollHintUpdate);
  queueNormalizeFlexibleColumnRows();
  queueMobileScrollHintUpdate();
  }

  function initAllFlexibleColumnsSections(root) {
    const scope = root || document;
    if (scope.matches && scope.matches('.shopify-section') && scope.querySelector('.gf-flexible-columns')) {
      initFlexibleColumnsSection(scope);
    }

    scope.querySelectorAll('.shopify-section').forEach(function(sectionRoot) {
      if (sectionRoot.querySelector('.gf-flexible-columns')) {
        initFlexibleColumnsSection(sectionRoot);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllFlexibleColumnsSections(document);
    });
  } else {
    initAllFlexibleColumnsSections(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllFlexibleColumnsSections(event.target);
  });
})();
